import { CompLocationMultiCore } from '../core/location-multi/comp'

export const CompLocationMulti = CompLocationMultiCore
